import React from 'react'

import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

const ClassificationMenu = (props) => {  
  const { handleChange } = props
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <ListItem button onClick={handleClick}>
        <ListItemText primary="Classifica" />
      </ListItem>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          styles={{  maxWidth: "360px", minWidth: "150px"}}
        >
         
         <ListItem button onClick={() => {handleClose(); handleChange("std_collegio")}}>
            <FiberManualRecordIcon style={{color: "#666999"}} />
            <ListItemText primary="Predefinito" />
          </ListItem>                  
          <ListItem button onClick={() => {handleClose(); handleChange("hidden_collegio")}}>
            <FiberManualRecordIcon style={{color: "#444444"}} />
            <ListItemText primary="Nascosto" />
          </ListItem>          
        </List>
      </Popover>
    </>
  )
}

export default ClassificationMenu
